// extracted by mini-css-extract-plugin
export default {"nameWrapper":"EmailSection_nameWrapper","name":"EmailSection_name","nameFullView":"EmailSection_nameFullView","changeEmailButton":"EmailSection_changeEmailButton"};